export default __webpack_public_path__ + "static/media/carousel-1.ded23d13.png";